import { webshopService } from '../../shared/services/WebshopService'
import { OrderWizardActionTypes as actions } from '../store/action-types'

export default class ProductConfigInitializer {
  constructor ({ store }) {
    this.store = store
    return this.init()
  }

  async init () {
    const productConfig = await webshopService.getProductConfig()
    const productsInCart = this.store.getters.getProductsInCart()
    if (productsInCart.length === 0) return

    for (let i = 0; i < productsInCart.length; i++) {
      const cartProduct = productsInCart[i]
      const productGroup = productConfig.productGroups.filter(group => group.code === cartProduct.groupCode)
      if (productGroup.length === 0) {
        this.clearCart()
        return
      }

      const productPackageInGroup = productGroup[0].packages.filter(p => p.code === cartProduct.code && p.loyaltyLength === this.store.state.selectedLoyalty)
      if (productPackageInGroup.length === 0) {
        this.clearCart()
        return
      }

      if (JSON.stringify(cartProduct.product) !== JSON.stringify(productPackageInGroup[0])) {
        this.clearCart()
        return
      }
    }
  }

  clearCart (store) {
    this.store.dispatch(actions.CLEAR_CART)
  }
}
